var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Marker } from 'react-map-gl';
import { MapPopup } from './map-popup';
export var MapMarkerDefaultProps = {
  scaleFactor: 10,
  maxSize: 40,
  items: [],
  anchor: 'bottom'
};
// -------- Styles -------->
var BodyStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    position: relative;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: ", ";\n    position: relative;\n  "])), theme.COLOR('text'))
});
var PopupStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    z-index: 300;\n  "], ["\n    margin-bottom: ", ";\n    z-index: 300;\n  "])), theme.UNIT(4))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.REMOVE_BUTTON_STYLE())
});
// -------- Components -------->
var My = {
  Body: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  MarkerButton: styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Popup: styled(MapPopup)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), PopupStyles)
};
export var MapMarker = function (props) {
  var className = props.className,
    zoom = props.zoom,
    maxSize = props.maxSize,
    scaleFactor = props.scaleFactor,
    children = props.children,
    isSelected = props.isSelected,
    items = props.items,
    onClick = props.onClick,
    onClose = props.onClose,
    popup = props.popup,
    rest = __rest(props, ["className", "zoom", "maxSize", "scaleFactor", "children", "isSelected", "items", "onClick", "onClose", "popup"]);
  return React.createElement(Marker, __assign({}, rest, {
    anchor: "bottom"
  }), React.createElement(My.Body, null, popup && React.createElement(My.Popup, {
    className: className,
    onClose: onClose
  }, popup), React.createElement(My.MarkerButton, {
    onClick: onClick
  }, children)));
};
MapMarker.defaultProps = MapMarkerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;